// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"595":"08262b24","628":"fee7c843"}[chunkId] + ".chunk.css";
};